<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="label-row">
	{{ label }}
</div>

<div class="month-year-row">
	{{ monthAndYear$ | async }}
</div>

<mat-chip-listbox [formControl]="chipListFormControl" [selectable]="true" [multiple]="true">
	<!-- BEGIN PLACEHOLDER REPLACE AS PART OF TP-6648 [ngClass] -->
	<mat-chip-option
		*ngFor="let chipData of chips$ | async; let i = index"
		[value]="chipData"
		[disabled]="!chipData.enabled"
		[ngClass]="chipData.colorNgClass"
		>{{ chipData.dayName }}&nbsp;{{ chipData.date }}
	</mat-chip-option>
	<!-- END PLACEHOLDER REPLACE AS PART OF TP-6648 -->
</mat-chip-listbox>

<div class="non-workdays-row">
	{{ nonWorkdaysLabel$ | async }}
</div>
